import * as React from 'react';
import { throttle } from 'lodash';
import classnames from 'classnames';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import BulkOfferCustomizedFormField from 'modules/subcampaigns/components/bulk/bulk-offer-customized-form-field/BulkOfferCustomizedFormField';

import { __t, applyTranslations } from 'utils/language';
import { LONG_STRING_MAX_LENGTH, maxLength } from 'utils/validators';

applyTranslations(require('./offer-personal-message.i18n.json'));

type Props = {
  personalMessage?: string,
  onEdit: (a: any) => void,
  hideInfoNote?: boolean,
  isBulkOfferActive?: boolean,
  renderCustomizeButton?: () => React.ReactNode
};

type State = {
  personalMessage: string
};

const FORM_FIELD_PROPS: Partial<React.ComponentProps<typeof FormField>> = {
  label: __t('offer_personal_message.label'),
  labelType: 'highlighted',
  showValidationIcon: false,
  direction: 'column',
  fontSize: 'small'
};

class OfferPersonalMessageForm extends React.PureComponent<Props, State> {
  throttledHandleEdit: () => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      personalMessage: this.props.personalMessage || ''
    };

    this.throttledHandleEdit = throttle(this.handleFormEdit, 1000);
  }

  handleMessageChanged = (event: Event): void => {
    const target = event.currentTarget;
    const value = target instanceof HTMLTextAreaElement && target.value || '';

    if (this.state.personalMessage !== value) {
      this.setState({
        personalMessage: value
      }, this.throttledHandleEdit);
    }
  };

  handleFormEdit = () => {
    const { onEdit } = this.props;
    const { personalMessage } = this.state;

    onEdit({
      personalMessage
    });
  };

  render() {
    const { hideInfoNote, isBulkOfferActive, renderCustomizeButton } = this.props;
    const { personalMessage } = this.state;

    const sectionClasses = classnames('offer-legal-requirements-form__section', {
      'offer-legal-requirements-form__section--with-info-note': !hideInfoNote
    });

    return (
      <section
        className="offer-legal-requirements-form"
        data-qa="offer-legal-requirements-form"
      >
        <div className={sectionClasses}>
          <BulkOfferCustomizedFormField
            fieldName="personalMessage"
            formFieldProps={FORM_FIELD_PROPS}
            isBulkOfferActive={!!isBulkOfferActive}
          >
            <FormField
              {...FORM_FIELD_PROPS}
              validators={[
                maxLength(personalMessage, LONG_STRING_MAX_LENGTH)
              ]}
            >
              <Input
                multiline
                value={personalMessage}
                width="responsive"
                onChange={this.handleMessageChanged}
                placeholder={__t('offer_personal_message.placeholder')}
                data={{ qa: 'plain-text-form__input' }}
              />
            </FormField>
          </BulkOfferCustomizedFormField>
          {
            isBulkOfferActive && renderCustomizeButton &&
            <React.Fragment>
              <VerticalSpacing type="medium" />
              {renderCustomizeButton()}
            </React.Fragment>
          }
        </div>
      </section>
    );
  }
}

export default OfferPersonalMessageForm;
